/**
 * ngrok’s free tunnel can serve an HTML interstitial for “browser-like” requests.
 * Without this header, client `fetch()` to Remix routes may get HTML instead of JSON
 * (e.g. empty or broken `transactionData` on `/cashflow/transactions`).
 *
 * Safe to send on every host — ignored outside ngrok.
 *
 * @see https://ngrok.com/docs/troubleshooting/http-inspect/
 */
export function withDevTunnelHeaders(init?: RequestInit): RequestInit {
  const headers = new Headers(init?.headers);
  if (!headers.has("ngrok-skip-browser-warning")) {
    headers.set("ngrok-skip-browser-warning", "true");
  }
  return { ...init, headers };
}
